import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { AddGetWay } from "../../services/getWay";
import { NumericFormat } from "react-number-format";
import { ToastContainer } from "react-toastify";
import { handleToast } from "../../services/config";
import { useNavigate } from "react-router-dom";
import { sendOtp } from "../../services/beneficiaries";
import { contextApi } from "../../context/contextApi";
import { useContext } from "react";

export const RecivePeymentForm = () => {
  const [timer, setTimer] = useState(0);
  const context = useContext(contextApi);
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    getValues,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    try {
      if (countDown != "اتمام زمان شما") {
        const dataResponse = {
          "gateway":"vandapardakht",
          amount: parseInt(String(data.money).replace(/,/g, "")),
          payer_mobile: data.shaba,
          des: data.description,
        };
        await AddGetWay(dataResponse);
        reset();
        setValue("money", " ");
      } else {
        handleToast("error", "زمان شما یه پایان رسید لطفا صفحه را رفرش کنید");
      }
    } catch (error) {}
  };
  const [time, setTime] = useState("");
  const [countDown, setCountDown] = useState("10:00");
  var timerInterval;
  useEffect(() => {
    let now = new Date();
    let nowTimw =
      now.getHours() +
      ":" +
      (now.getMinutes() < 10 ? "0" + now.getMinutes() : "" + now.getMinutes());
    setTime(nowTimw + " - " + now.toLocaleDateString("fa-IR"));
  }, []);

  useEffect(() => {
    const storedStartTime = localStorage.getItem("startTime");
    // if (!storedStartTime) {
    //   const startTime = Math.floor(Date.now() / 1000);
    //   localStorage.setItem("startTime", startTime.toString());
    // }
    const currentTime = Math.floor(Date.now() / 1000);
    const elapsedTime = currentTime - parseInt(storedStartTime, 10);
    if (elapsedTime < 120) {
      setTimer(120 - elapsedTime);
    }
  }, []);

  useEffect(() => {
    timerInterval = setInterval(startTimer, 1000);
    return () => clearInterval(timerInterval);
  }, []);

  const [isDark, setIsDark] = useState(
    () =>
      typeof window !== "undefined" && document.body.classList.contains("dark")
  );

  useEffect(() => {
    const checkDark = () => setIsDark(document.body.classList.contains("dark"));
    checkDark();
    const observer = new MutationObserver(() => {
      checkDark();
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  var timeLimitInMinutes = 10;
  var timeLimitInSeconds = timeLimitInMinutes * 60;
  function startTimer() {
    timeLimitInSeconds = timeLimitInSeconds - 1;
    var minutes = Math.floor(timeLimitInSeconds / 60);
    var seconds = timeLimitInSeconds % 60;

    if (timeLimitInSeconds < 0) {
      setCountDown("اتمام زمان شما");
      handleToast("error", "زمان شما یه پایان رسید لطفا صفحه را رفرش کنید");
      clearInterval(timerInterval);
      return;
    }

    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    setCountDown(minutes + ":" + seconds);
  }
  const [load, setLoad] = useState(false);
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);
  const handlSendOTP = async () => {
    // Check if money and shaba fields are filled
    const formValues = getValues();
    const moneyValue = formValues.money;
    const shabaValue = formValues.shaba;

    // Remove comma separators from money value for validation
    const moneyWithoutCommas = moneyValue
      ? String(moneyValue).replace(/,/g, "")
      : "";

    // چک کردن اینکه همه فیلدها پر شده باشند
    const missingFields = [];

    if (
      !moneyWithoutCommas ||
      moneyWithoutCommas === "" ||
      moneyWithoutCommas === "0"
    ) {
      missingFields.push("مبلغ");
    }
    if (!shabaValue || shabaValue.trim() === "" || shabaValue.length !== 11) {
      missingFields.push("شماره موبایل پرداخت کننده");
    }

    if (missingFields.length > 0) {
      handleToast("error", `لطفا ${missingFields.join("، ")} را وارد کنید`);
      return;
    }

    const startTime = Math.floor(Date.now() / 1000);
    localStorage.setItem("startTime", startTime.toString());
    setTimer(120);
    const bodyOtp = {
      mobile: localStorage.mobile, // در صورتی که کاربر وارد نشده بود
    };
    try {
      setLoad(true);
      await sendOtp(bodyOtp);
      handleToast("success", "کد ارسال شده را وارد کنید");
    } catch (error) {
      setTimer(0);
      localStorage.removeItem("startTime");
    }
    setTimeout(() => {
      setLoad(false);
    }, 500);
  };

  const handleClick = (buttonName) => {
    context.recordClick(buttonName);
  };

  return (
    <>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          position: "fixed",
          top: "20px",
          left: "20px",
          zIndex: 9999,
        }}
      />
      <div
        className={`form  rounded-2xl shadow p-3 max-w-full md:w-3/4 lg:w-2/4 mx-10 md:mx-auto md:p-3  lg:p-6 ${
          isDark ? "card" : "card2"
        }`}
      >
        <div className="point bg-green-100 rounded px-2 py-1">
          <p className="text-[#0D1117]">
            نکته پیام ارسالی ۲۴ ساعت اعتبار دارد{" "}
          </p>
        </div>
        <p className="mt-3 font-vazir-num">
          <span className="text-[#0010c6] dark:text-white">
            تاریخ و ساعت :{" "}
          </span>
          <span className="text-sm text-[#0010c6] dark:text-white">{time}</span>
        </p>
        <p className="mt-3 text-left font-vazir-num">
          <span className="text-[#0010c6] dark:text-white">
            زمان باقیمانده:{" "}
          </span>
          <span className="text-sm text-[#0010c6] dark:text-white">
            {countDown}
          </span>
        </p>
        <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          <label
            htmlFor=""
            className="text-xs  m-0 text-[#0010c6] dark:text-white"
          >
            مبلغ(ریال)
          </label>
          <Controller
            control={control}
            name="money"
            {...register("money", { required: true })}
            placeholder={"۰ ریال"}
            render={({ field: { onChange, name, value } }) => (
              <NumericFormat
                className={`w-full border text-black bg-gray-100 dark:bg-gray-400 rounded-md px-2 py-1 text-xs placeholder:text-left font-normal outline-none ${
                  (errors["money"] && "bg-red-100 border border-red-400") || ""
                }`}
                thousandSeparator=","
                name={name}
                value={value}
                onChange={onChange}
              />
            )}
          />

          {errors["money"] && (
            <p className="text-red-400 text-xs">لطفا مبلغ خود را وارد کنید</p>
          )}
          <label
            htmlFor=""
            className="text-xs  m-0 text-[#0010c6] dark:text-white"
          >
            شماره موبایل پرداخت کننده وجه
          </label>
          <input
            {...register("shaba", {
              required: true,
              maxLength: 11,
              minLength: 11,
            })}
            placeholder={""}
            type={"text"}
            className={`w-full border text-black bg-gray-100 dark:bg-gray-400 rounded-md px-2 py-1 text-xs placeholder:text-left font-normal outline-none ${
              (errors["shaba"] && "bg-red-100 border border-red-400") || ""
            }`}
          />
          {errors["shaba"] && (
            <p className="text-red-400 text-xs">
              لطفا شماره موبایل پرداخت کننده خود را به درستی وارد کنید
            </p>
          )}
          <label
            htmlFor=""
            className="text-xs  m-0 text-[#0010c6] dark:text-white"
          >
            توضیحات
          </label>
          <textarea
            {...register("description", { required: false })}
            rows={3}
            type={"text"}
            className={`w-full border text-black bg-gray-100 dark:bg-gray-400 rounded-md px-2 py-1 text-xs placeholder:text-left font-normal outline-none ${
              (errors["description"] && "bg-red-100 border border-red-400") ||
              ""
            }`}
          />
          {errors["description"] && <p className="text-red-400 text-xs"></p>}
          <label
            htmlFor=""
            className="text-xs  m-0 block text-[#0010c6] dark:text-white"
          >
            کد تایید
          </label>
          <input
            {...register("Payer-number", { required: true })}
            placeholder={""}
            type={"number"}
            className={`w-2/4 md:w-4/5 border text-black bg-gray-400 rounded-md px-2 py-1 text-xs placeholder:text-left font-normal outline-none ${
              (errors["Payer-number"] && "bg-red-100 border border-red-400") ||
              ""
            }`}
          />
          <button
            className={`text-center bg-blue-500 w-5/12 md:w-1/6 float-left py-1 mr-auto text-white rounded text-sm ${
              timer > 0
                ? "opacity-50 bg-gray-500 text-[10px] cursor-not-allowed"
                : ""
            }`}
            onClick={handlSendOTP}
          >
            ارسال کد تایید
            {timer > 0 && ` (${timer}s)`}
          </button>
          {errors["Payer-number"] && (
            <p className="text-red-400 text-xs">لطفا کد تایید را وارد کنید</p>
          )}
          <div className="w-full flex  gap-3">
            <button
              className="btn-add text-center mt-3 shadow bg-red-500 w-1/2 rounded text-white p-1 text-sm"
              onClick={() => navigate("/")}
            >
              {" "}
              لغو
            </button>
            <input
              type="submit"
              value={"ارسال"}
              onClick={() => {
                handleClick("ارسال در لینک دریافت وجه کلیک شد");
              }}
              disabled={!isValid}
              className="btn-add text-center mt-3 shadow disabled:bg-slate-400 bg-green-600 w-1/2 rounded text-white p-1 text-sm"
            />
          </div>
        </form>
      </div>
    </>
  );
};
